<template>
  <div class="wrapper">
    <div class="bg-page" :style="bgPage">
      <div class="text-center" style="color: black; background: #ddd;">
        <h1>{{ msg }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// import validator from 'validator';
// import router from '../../../../router';
import backgroundImage1 from '../../../../assets/bg_login.png';

export default {
  data: () => ({
    msg: '',
    bgPage: {
      background: null,
      backgroundRepeat: null,
      backgroundSize: null,
      backgroundPosition: null,
    },
    url: 'https://api.bi-assobens.com.br/v1',
    // url: 'http://localhost:3000/v1',
  }),

  async created() {
    this.msg = 'Autenticando...';
    const imgs = [
      backgroundImage1,
    ];
    this.bgPage.background = `url('${imgs[Math.floor(Math.random())]}')`;
    this.bgPage.minHeight = '100vh';
    this.bgPage.minWidth = '100vw';
    this.bgPage.backgroundRepeat = 'no-repeat';
    this.bgPage.backgroundSize = 'cover';
    this.bgPage.backgroundAttachment = 'fixed';
    this.bgPage.backgroundPosition = 'center';

    const { token } = this.$route.params;
    try {
      // eslint-disable-next-line
      const { data } = await axios.get(
        `${this.url}/sso/${token}`,
        { headers: { 'Access-Control-Allow-Origin': '*' } },
      );
      this.msg = 'Autenticado...';
      this.$store.state.auth.isSSO = true;
      localStorage.setItem(
        '_pbiAssobens',
        JSON.stringify({
          id: data.id,
          token: data.token,
          email: data.email,
          type: data.type,
          isSSO: true,
          isVendas: data.isVendas,
          isPosVendas: data.isPosVendas,
          segmentos: data.segmentos,
        }),
      );
      this.$router.push('/home');
    } catch (error) {
      this.msg = 'Falha na autenticação';
    }
  },
};
</script>
